module.exports = __webpack_public_path__ + "img/words11.de5caf4b.png";